var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.AWBSubmit('validate')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBnumberparent),
      expression: "AWBnumberparent"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "AWBnumberparent",
    class: {
      'form-control': true
    },
    attrs: {
      "name": "AWBnumberparent",
      "data-vv-scope": "validate",
      "placeholder": "Enter AWB No"
    },
    domProps: {
      "value": (_vm.AWBnumberparent)
    },
    on: {
      "keypress": function($event) {
        return _vm.preventSpecialChar($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBnumberparent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('validate.AWBnumberparent')),
      expression: "errors.has('validate.AWBnumberparent')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("AWB No is required")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.Branchloading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    staticStyle: {
      "font-size": "1.2rem"
    }
  })]), _vm._v("  \n            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "card-body1 col-md-4",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, [_vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      style: (("" + ((_vm.tabs.length==1) ? 'width: 100%;' : ''))),
      attrs: {
        "id": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction(tab);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + " " + _vm._s((tab.value == 'Pending') ? '(' + tab.count + ')' : '') + "\n          ")])
  }), _vm._v(" "), _c('keep-alive', [_c(_vm.currentTabComponent, {
    key: _vm.componentKey,
    tag: "component",
    staticClass: "tab"
  })], 1)], 2), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.awbLoading
    },
    on: {
      "update:active": function($event) {
        _vm.awbLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [(_vm.hideFilter == 0) ? _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "margin-left": "0px",
      "width": "100%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.hideFilter = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter filter"
  }), _vm._v("Filter\n              ")]) : _vm._e(), _vm._v(" "), (_vm.hideFilter == 1) ? _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "margin-left": "0px",
      "width": "100%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.hideFilter = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter filter"
  }), _vm._v("Filter\n              ")]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    style: (("" + (_vm.hideFilter == '1' ? 'display: block !important; margin-top: 1%;' : 'display: none !important; margin-top: 1%;'))),
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "form-2"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit('fromscope')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Inscan:From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.todate ? new Date(_vm.todate).setDate(new Date(_vm.todate).getDate() - 6) : '',
      "not-after": (_vm.todate) ? _vm.todate : _vm.todaysDate,
      "name": "FromDate"
    },
    model: {
      value: (_vm.FromDate),
      callback: function($$v) {
        _vm.FromDate = $$v
      },
      expression: "FromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromscope.FromDate')),
      expression: "errors.has('fromscope.FromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("From Date is required")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.FromDate,
      "not-after": (_vm.FromDate && (new Date(_vm.FromDate).setDate(new Date(_vm.FromDate).getDate() + 6)) < _vm.todaysDate) ? new Date(_vm.FromDate).setDate(new Date(_vm.FromDate).getDate() + 6) : _vm.todaysDate,
      "name": "todate"
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromscope.todate')),
      expression: "errors.has('fromscope.todate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("To Date is required")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("FM Branch")]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('model-select', {
    attrs: {
      "data-vv-scope": "fromscope",
      "options": _vm.FMBranchData,
      "placeholder": "Select FM Branch",
      "name": "FMBranch"
    },
    model: {
      value: (_vm.FMBranch),
      callback: function($$v) {
        _vm.FMBranch = $$v
      },
      expression: "FMBranch"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.currentTab == 'completed') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Verification: From Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "not-before": _vm.vtodate ? new Date(_vm.vtodate).setDate(new Date(_vm.vtodate).getDate() - 6) : '',
      "not-after": (_vm.vtodate) ? _vm.vtodate : _vm.todaysDate,
      "name": "VFromDate"
    },
    model: {
      value: (_vm.VFromDate),
      callback: function($$v) {
        _vm.VFromDate = $$v
      },
      expression: "VFromDate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromscope.VFromDate')),
      expression: "errors.has('fromscope.VFromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("From Date is required")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("To Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control1': true
    },
    attrs: {
      "data-vv-scope": "fromscope",
      "lang": "en",
      "type": "date",
      "format": "YYYY-MM-DD",
      "name": "vtodate",
      "not-before": _vm.VFromDate,
      "not-after": (_vm.VFromDate && (new Date(_vm.VFromDate).setDate(new Date(_vm.VFromDate).getDate() + 6)) < _vm.todaysDate) ? new Date(_vm.VFromDate).setDate(new Date(_vm.VFromDate).getDate() + 6) : _vm.todaysDate
    },
    model: {
      value: (_vm.vtodate),
      callback: function($$v) {
        _vm.vtodate = $$v
      },
      expression: "vtodate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromscope.vtodate')),
      expression: "errors.has('fromscope.vtodate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("To Date is required")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [(_vm.currentTab == 'completed') ? _c('label') : _vm._e(), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v("  \n                             "), _c('button', {
    staticClass: "common-danger",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "Reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHub('hubsave')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "30px"
    }
  }, [_c('div', {
    staticClass: "col-md-10 cardlistheader"
  }, [_c('b', [_vm._v("Total Record: " + _vm._s(_vm.totalAWBRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "height": "30px"
    }
  }, [(_vm.totalAWBRows > 0) ? _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.exportAWB()
      }
    }
  }, [_vm._v("Download .csv")]) : _vm._e()])]), _vm._v(" "), _c('div'), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover datatables tbl",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No of Boxes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Inscan Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pickup Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("FM Branch ")]), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Verification Date")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pickup Physical Weight(kg) ")]), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Verified Physical Weight(kg)")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pickup Volumet Weight(kg)")]), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Verified Volumet Weight(kg)")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Branch")]), _vm._v(" "), (_vm.currentTab == 'pending') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB Verification Method")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.AWBResponse), function(AWBData) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.AWB))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.MPSCount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.InScanDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.PickupDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.FMBranch))]), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.VerificationDate))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.PhysicalWeight))]), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.VerifiedPhysicalWeight))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.VolumetricWeight))]), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.VerifiedVolumetricWeight))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.DestinationName))]), _vm._v(" "), (_vm.currentTab == 'pending') ? _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "href": '/#/AWBVerificationDimWt_v1?AWBNo=' + AWBData.AWB + '&destinationhubId=' + AWBData.FinalDestinationID
      }
    }, [_vm._v("Verify")])]) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'completed') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(AWBData.AWBVerificationMethod))]) : _vm._e()])
  }), _vm._v(" "), (_vm.AWBResponse.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": (_vm.currentTab == 'completed') ? 12 : 9
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalAWBRows > 0),
      expression: "totalAWBRows>0"
    }],
    ref: "paginate",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 10,
      "margin-pages": 10,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination',
      "initial-page": _vm.pageNo - 1
    }
  })], 1)], 1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-7",
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("AWB Verification (Dim&Wt) Dashboard")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ef2dff7","hasScoped":true}!./src/views/components/AWBPendingVerification/AWBPendingVerification.component.html
// module id = 1633
// module chunks = 2